import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import axios from 'axios'
//import $ from 'jquery'
moment.locale('es')

import LazyLoad from 'react-lazyload';

import DFPAdsProvider from '@univision/fe-commons/dist/components/ads/dfp/DFPAdsProvider';
import DFPAd from '@univision/fe-commons/dist/components/ads/dfp/DFPAd';
import BKPIndicator from '@univision/fe-commons/dist/components/breakpoint/BreakPointIndicator';


import { pageData } from '../config/advertising';

import adHelper from '@univision/fe-commons/dist/utils/ads/adHelper';
import AdSettings from '@univision/fe-commons/dist/utils/ads/adSettings.json';
import * as AdTypes from '@univision/fe-commons/dist/utils/ads/ad-types';
import { track_click }  from '../components/tracking';
import Tracking  from '../components/tracking';
import LogoChamp from '../images/logo-champions.svg';
import QuoteOpen from '../images/quote1.png';
import QuoteClose from '../images/quote2.png';

var cut_first_ad = 0, ad_shown = 0, sum_character = 0;

class BlogPostRoute extends React.Component {
      componentDidMount(){
          try {
            setTimeout(() => {
              window.scrollTo(0, 0)
            }, 100);
          }catch(e){}
      }
      replaceAll(target, search, replacement) {
          return target.replace(new RegExp(search, 'g'), replacement);
      };
      callDFPAd = (type, index) => {
        const adSettings = AdSettings[AdTypes[type]];
        const settings = adHelper.getSettings(adSettings);
        let is_mobile = document == undefined ? false : document.body.clientWidth < 768; //$(window).width() < 768;
        
        var _ad = (
          <div style={{ "textAlign": "center" }}>
            <BKPIndicator />
            <div className="container-advertising">
              <DFPAdsProvider
                  env={pageData.env}
                  settings={pageData.data.adSettings}
                  requestParams={pageData.requestParams}
                  contentType={pageData.data.type}
              >
                  <DFPAd {...settings}  />
              </DFPAdsProvider>
            </div>
          </div>
        );
        var _ad_empty = (<div></div>);

        if(!is_mobile){
          if(ad_shown == 0 && ( index >= 15 || sum_character >= 700 ) )
          {
            cut_first_ad = index;
            ad_shown++;
            return _ad;
          }
          else if( ad_shown > 0 && ( (index - cut_first_ad) % 8 == 0  ) )
          {
            ad_shown++;
            return _ad;
          }
        }
        else {
          if(ad_shown == 0 && ( index >= 8 || sum_character >= 500 ) )
          {
            cut_first_ad = index;
            ad_shown++;
            return _ad;
          }
          else if( ad_shown > 0 && ( (index - cut_first_ad) % 8 == 0  ) )
          {
            ad_shown++;
            return _ad;
          }
        }
        return _ad_empty;
        
    };
    render() {
      const node = this.props.pathContext.node 

      var index_body = -1;
      return node == null || typeof document === 'undefined' ? (<div></div>) : (
        <div className="uvn-la-otra-cara-internal">
          <Tracking pageName={ node.title.toLowerCase().replace(',', '') } permalink={window.location.href} />
            <img src={LogoChamp} className="logo-champ" />
            
            <h1 className="titulo_episodio">{node.title}</h1>

              <div className="descripcionEpisodio"> {node.description}  </div>
              <div className="info_publicacion">
                <div className="datos_publicacion">
                      <img src={node.author_image} className={node.author_image == "" ? "hide": "imagen_autor"} />
                      <div className="texto_autor">
                        <span className="autor">{node.author_name}</span>
                        <span className="fecha">{moment(node.publishDate).format('MMM DD[,] YYYY [-]  h:mm a')}</span> 
                      </div>      
                </div>
                <div className="contieneCompartir">
                  <span>COMPARTE</span>
                  <ul className="compartirEpisodio">
                      <li className="share_facebook">
                        <a href={"https://www.facebook.com/sharer/sharer.php?u="+ encodeURIComponent(window.location.href) }  onClick={
                          function openFacebook(e){
                            track_click("UCLIShareFBEp" + node.index);
                            e.preventDefault();  
                            window.open('https://www.facebook.com/sharer/sharer.php?u= '+ encodeURIComponent(window.location.href) , 'facebook-popup', 'height=350,width=600'); 
                          }
                          }></a>
                      </li>
                      <li className="share_twitter">
                        <a href={"https://twitter.com/intent/tweet?"}  title={"Share on Twitter"} onClick={
                          function openTwitter(e){
                            track_click("UCLShareTWEp" + node.index);
                            e.preventDefault();
                            window.open('https://twitter.com/intent/tweet?text=' + encodeURIComponent(node.title) + ':%20 ' + encodeURIComponent(window.location.href) + ' via: @' +node.article_sharing[0].sharing_via , 'facebook-popup', 'height=350,width=600');
                          }
                        }></a>
                      </li>
                      <li className="share_mail">
                        <a  href={"mailto:?subject=&body=:%20"} onClick={
                          function openMail(e){
                            track_click("UCLShareMailEp" + node.index);
                            e.preventDefault();
                            window.location.href = ('mailto:?subject=' + encodeURIComponent(node.title) + '&body=' + encodeURIComponent(node.title+' \n\n' +node.article_sharing[0].sharing_mail+' \n\n Conoce todo el especial en: ' +window.location.href));
                          }
                        } ></a>
                      </li>
                    </ul> 
                  </div>
                </div>
                <img src={node.image_lead} className="img_lead_internal"/>
                <div className="caption-image-body" dangerouslySetInnerHTML={{__html: node.image_lead_caption}}></div> 
              <div>
              {node.article_body.map(({ fragment, fragmentText, embeds_request, fragmentCaption, fragmentInfo, fragmentSlides, fragmentQuote }) => {
                
                if(fragment == undefined) {return;}
                index_body++;
                switch (fragment) {
                  case "text":
                    var ele = document.createElement("DIV");
                    ele.innerHTML = fragmentText;
                    sum_character += ele.textContent.length; //$(fragmentText).text().length;
                    return fragmentText == '<p><br /></p>' ? ("") : (
                      <div>
                        <div key={"body-" + index_body} dangerouslySetInnerHTML={{__html: fragmentText}} className="texto_episodio"/>
                        <LazyLoad > 
                            {this.callDFPAd("TOP_AD", index_body)}
                        </LazyLoad> 
                      </div>
                    )
                    
                  case "quoteenhancement":
                    var ele = document.createElement("DIV");
                    ele.innerHTML = fragmentText;
                    sum_character += ele.textContent.length; 
                    return fragmentText == '<p><br /></p>' ? ("") : (
                      <div>
                        <div className="content-quote">
                          <img src={QuoteOpen} className="quote-open-img" />
                          <div key={"body-" + index_body} dangerouslySetInnerHTML={{__html: this.replaceAll(fragmentQuote, '\n', '<br />') }} className="quote" />
                          <img src={QuoteClose} className="quote-close-img" />
                        </div>
                        <LazyLoad > 
                            {this.callDFPAd("TOP_AD", index_body)}
                        </LazyLoad> 
                      </div>
                    )

                  case "video":
                    axios({
                        method: `get`,
                        url: `${embeds_request}`
                    }).then(result3 => {
                       document.querySelector(".video-" + result3.data.data.uid + " .ifr").innerHTML = result3.data.data.embeds[0].iframeCode;
                       document.querySelector(".video-" + result3.data.data.uid + " .ifr iframe").classList.add("iframe_video");
                       document.querySelector(".video-" + result3.data.data.uid + " .ifr iframe").setAttribute("frameborder", "0");
                    });
                    return (
                      <div className={"content-iframe video-" + fragmentText}>
                          <div className="video-wrapper ifr"></div>
                          <LazyLoad > 
                              {this.callDFPAd("TOP_AD", index_body)}
                          </LazyLoad> 
                      </div>
                    )
                    break;
                  case "externalcontent":
                    return (
                      <div className={"content-iframe video-" + fragmentText}>
                          <div className="video-wrapper ifr" dangerouslySetInnerHTML={{__html: fragmentText}}></div>
                          <LazyLoad > 
                              {this.callDFPAd("TOP_AD", index_body)}
                          </LazyLoad> 
                      </div>
                    )
                    break;
                  case "image":
                    const styles = fragmentInfo != null && fragmentInfo.style != undefined ? JSON.parse(this.replaceAll(fragmentInfo.style, "'", '"') ) : {};
                    const its_inline_caption = ( fragmentInfo != null ? fragmentInfo.width == "inline-caption" : false );
                    
                    return (
                      <div className={ ( fragmentInfo != null && fragmentInfo.div != undefined ? fragmentInfo.div : "" ) }>
                        <div className={"content-image-with-caption" + ( fragmentInfo != null ? " " + fragmentInfo.width : "" ) }>
                          <img className={"imgBody" + ( fragmentInfo != null ? " " + fragmentInfo.width : "" )} style={ styles } key={"body-" + index_body} src={ fragmentText} />       
                          <div className={ (its_inline_caption ? "inline-caption" : "caption-image-body") } dangerouslySetInnerHTML={{__html: fragmentCaption}}></div>              
                        </div>
                        <LazyLoad > 
                            {this.callDFPAd("TOP_AD", index_body)}
                        </LazyLoad> 
                      </div>
                    )

                  case "slideshow":
                    console.log({fragmentSlides});
                    return (
                      <div className="content-jugadores">
                        <ul>
                          {fragmentSlides.map(({ fragment, fragmentCaption, fragmentInfo, fragmentText }) => {
                            const styles = fragmentInfo != null && fragmentInfo.style != undefined ? JSON.parse(this.replaceAll(fragmentInfo.style, "'", '"') ) : {};
                            return (
                                <li>
                                  <img className={"imgBody" + ( fragmentInfo != null ? " " + fragmentInfo.width : "" )} style={ styles } key={"body-" + index_body} src={ fragmentText} />       
                                  <div className="caption-image-body" dangerouslySetInnerHTML={{__html: fragmentCaption}}></div>              
                                </li>
                              )
                          } )}  
                        </ul>
                      </div>
                    )
                  default:
                    return (
                      <div>
                        <div key={"body-" + index_body} ></div>
                        <LazyLoad > 
                            {this.callDFPAd("TOP_AD", index_body)}
                        </LazyLoad> 
                      </div>
                    )
                    break;
                }
                
              
                })
              }
              </div>
        
  
        </div>
      )
    }

  }
  
  export default BlogPostRoute


// WEBPACK FOOTER //
// ./src/pages/internal.js